<template>
    <div class="product-detail">
      <h2 v-if="!isReview">{{currObj.title}}</h2>
      <div class="image-container wp-relative">
        <div class="big-image">
          <swiper 
          :modules="modules" 
          :autoplay="{ delay: 2000, disableOnInteraction: false }"
          :loop="true"
          :slides-per-view="1" 
          :pagination="{ clickable: true }"
          @swiper="onBigSwiper"
          @slideChange="onSlideChange">
            <swiper-slide v-for="(image, index) in images" :key="index">
              <el-image  
              :class="{ active: activeIndex === index }"
              @click="setActiveImage(index)"
              alt="西雅图桃桃私人会所公主-{{ currObj.title }}" 
              :src="image"
              :fit="contain"></el-image>
              <!-- <img :src="image" :class="{ active: activeIndex === index }"  alt="Product Image" @click="setActiveImage(index)"> -->
            </swiper-slide>
          </swiper>
        </div>
        <div class="small-images">
          <swiper 
          :modules="modules" 
          :autoplay="{ delay: 2000, disableOnInteraction: false }"
          :loop="true"
          :slides-per-view="4" 
          :space-between="10" 
          @swiper="onSmallSwiper"
          @slideChange="onSlideChange" 
          :navigation="{
            enabled:true,
            hideOnClick:true,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }">
            <swiper-slide v-for="(image, index) in images" :key="index">
              <img :src="image" 
              :class="{ active: activeIndex === index }" 
              alt="西雅图桃桃私人会所公主-{{ currObj.title }}{{ index }}"  
              :fit="contain"
              @click="setActiveImage(index)">
            </swiper-slide>
            <div class="swiper-button-prev" @click="onPrev"></div>
            <div class="swiper-button-next" @click="onNext"></div>
          </swiper>
        </div>
      </div>
      <div v-if="!isReview" class="wp-relative" :style="{'margin-top': '130px','margin-bottom': '60px'}" > 
        <div class="wp-reviews" @click="handlReview()">
          <i class="iconfont icon-tools_u"  alt="点击查看实时客评"></i>  <h2>点击查看实时客评</h2></div>  
      </div> 
      
      <div v-if="!isReview" class="product-description">
        <!-- <h2>公主信息</h2>   -->
        <div class="wp-relative desc-detail">
          <div class="desc-item">名字： {{ currObj.title }}</div>
          <div class="desc-item">国籍： {{ currObj.nationality }}</div> 
          <div class="desc-item">年龄： {{ currObj.age }}</div>
          <div class="desc-item">身高： {{ currObj.stature }}</div>
          <div class="desc-item">体重： {{ currObj.weight }}</div>
          <div class="desc-item">胸围： {{ currObj.cir }}</div>
          <div class="desc-item">价格：</div> 
    
        </div> 
      </div>
      <div class="price-list">
              <div v-for="(item, index) in pricejson" :key="index" class="price-item">
                <div class="price-item-price">{{ item.price }}</div>
                <div class="price-item-des">{{ item.des }}</div>
              </div>
            </div>
      <div v-if="!isReview" class="product-description">
        <!-- <h2>公主简介</h2>   -->
        <div class="wp-relative "   v-html="currObj.infocontent"> </div>
      </div>
    </div>
  </template>
  
<script>
import { ref, onMounted } from 'vue'; 
import { useRouter } from 'vue-router';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation,Autoplay,Pagination  } from 'swiper'; 

import 'swiper/css';
import 'swiper/css/navigation'; 
import 'swiper/css/pagination'; 
import 'swiper/css/autoplay';


export default {
props: {
    images:{
        type:Array,
        default:() => []
    },
    currObj:{
      type:Object,
      default:() => {}
    },
    isReview:{
      type:Boolean,
      default:false
    }
},
components: {
    Swiper,
    SwiperSlide 
},
 
setup(props) {
  const productName = '商品名称';
  const productDescription = '这里是商品的详细描述，可以包含多行文本。';
  const images3 = [
    require('@/assets/banner/bg.jpg'),
    require('@/assets/banner/bg2.jpg'),
  ];
 
  const pricejson = ref([]);
  
  
  setTimeout(() => { 
    try{
      const parsedArr = JSON.parse(props.currObj?.pricejson)|| [];
      pricejson.value = parsedArr; 
      // console.log('延迟pricejson.value：', parsedArr); 
    }catch{
      pricejson.value = [];
    } 
  }, 100); 

  const activeIndex = ref(0);
  const bigSwiperInstance = ref(null);
  const smallSwiperInstance = ref(null); 
    

  const onNext = () =>{
      if (smallSwiperInstance.value) {
        smallSwiperInstance.value.slideNext(); 
        setActiveImage(smallSwiperInstance.value.realIndex);
      }
  };
  const onPrev = () =>{
      if (smallSwiperInstance.value) {
        smallSwiperInstance.value.slidePrev();
        activeIndex.value = smallSwiperInstance.value.realIndex;
        setActiveImage(smallSwiperInstance.value.realIndex);
      }
  }; 
  const onBigSwiper = (swiper) => { 
      bigSwiperInstance.value = swiper; 
    };

    const onSmallSwiper = (swiper) => { 
      smallSwiperInstance.value = swiper;
    };
  const onSlideChange = () => {
    // console.log('Slide changed');
  };

  const setActiveImage = (index) => {
    activeIndex.value = index;
    // console.log("---" +index);
    // 切换到指定的幻灯片
    if (bigSwiperInstance.value) {
      bigSwiperInstance.value.slideTo(index, 500, true);
      }
  };
 
  
  const router = useRouter();
  const   handlReview = () => { 
    // console.log('---title',props.currObj)
    let _title = props.currObj.title;
    router.push({ name: 'Review', params: { pid: props.currObj.id}, query: { title: _title } }); 
  };
  

  onMounted(()=>{  
  });
  return {
    productName,
    productDescription, 
    activeIndex,
    pricejson,
    images3,   
    onNext,
    onPrev, 
    setActiveImage,
    onBigSwiper,
    onSmallSwiper,
    onSlideChange,
    handlReview, 
    modules: {Navigation, Autoplay,Pagination} 
  };
}
};
</script>
    
<style lang="scss" scoped>
@import url(@/assets/css/commPage.scss);
  
.product-detail {
    max-width: 800px;
    margin: 0 auto; 
} 
.wp-reviews{ 
  background-color: #040435;
  font-weight: normal;
  border-radius: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 80%;
  margin: auto;
  color: var(--wp--preset--color--accent);
  // border: #c1924e 1px solid;
  &:hover{
    cursor: pointer;
  } 
  i{display: inline-block;font-size: 40px;color: #dfc680;}
  h2{
    display: inline-block;
    margin-left: 5px;
  }
}
.image-container {
margin: auto;
}
 
.big-image {
  position: relative;
  z-index: 1;
  padding-top: 2vh;
  padding-bottom:3px;
  width: 100%;
  max-width: 450px;
  margin: 0 auto; 
}
    
.small-images {  
  width: 100%;
  max-width: 450px;
  margin: auto;  
}
.swiper-button-prev{
  background-color: transparent;
}

.swiper-slide img {
    width: 100%;
    cursor: pointer;
    height: 15vh;
}

// .active {
// border: 2px solid #007bff;
// }
.big-image{
  :deep(.el-image__inner){
    height: 68vh!important;
  }
}
.small-images img{ 
    height: 15vh; 
}

.product-description {
margin-top: 20px;
}
.desc-detail{
  display: flex;
  flex-wrap: wrap;
}
.desc-item{ 
  text-align: left;
  color: #ffefbf;
  font-size: 17px;
  width: 40%;
  margin-left: 5%;
  padding: 0.6rem 0rem;
  white-space: nowrap;
  overflow: hidden;
}
.product-description h2 {
margin-bottom: 10px;
}


.price-item{
  text-align: left;
  color: #ffefbf;
  display: flex;
  padding: 0.3rem 1rem; 
  margin-left: 10px;
  font-size: 16px;
 .price-item-price{
    flex: 3;
 }
 .price-item-des{
    flex: 9;
 }
}

</style>